export const addEmblaDotClickHandlers = (emblaApi, dotsNode) => {
	dotsNode.forEach((dot, index) => {
		dot.addEventListener(
			'click',
			() => {
				emblaApi.scrollTo(index);
			},
			false
		);
	});

	const toggleDotsCurrent = () => {
		const previous = emblaApi.previousScrollSnap();
		const selected = emblaApi.selectedScrollSnap();
		dotsNode[previous].classList.remove('current');
		dotsNode[selected].classList.add('current');
	};

	emblaApi.on('init', toggleDotsCurrent).on('reInit', toggleDotsCurrent).on('select', toggleDotsCurrent);
};

export const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
	let dotNodes = [];
	const addDotBtnsWithClickHandlers = () => {
		dotsNode.innerHTML = emblaApi
			.scrollSnapList()
			.map(() => '<button class="embla__dot text-tan" type="button"></button>')
			.join('');

		const scrollTo = (index) => {
			emblaApi.scrollTo(index);
		};

		dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
		dotNodes.forEach((dotNode, index) => {
			dotNode.addEventListener('click', () => scrollTo(index), false);
		});
	};

	const toggleDotBtnsActive = () => {
		const previous = emblaApi.previousScrollSnap();
		const selected = emblaApi.selectedScrollSnap();
		dotNodes[previous].classList.remove('embla__dot--selected');
		dotNodes[selected].classList.add('embla__dot--selected');
	};

	emblaApi.on('init', addDotBtnsWithClickHandlers).on('reInit', addDotBtnsWithClickHandlers).on('init', toggleDotBtnsActive).on('reInit', toggleDotBtnsActive).on('select', toggleDotBtnsActive);

	return () => {
		dotsNode.innerHTML = '';
	};
};

export const addEmblaPrevNextClickHandlers = (emblaApi, prevBtn, nextBtn) => {
	prevBtn.addEventListener(
		'click',
		() => {
			emblaApi.scrollPrev();
		},
		false
	);
	nextBtn.addEventListener(
		'click',
		() => {
			emblaApi.scrollNext();
		},
		false
	);

	const togglePrevNextBtnsState = () => {
		if (emblaApi.canScrollPrev()) {
			prevBtn.removeAttribute('disabled');
		} else {
			prevBtn.setAttribute('disabled', 'disabled');
		}

		if (emblaApi.canScrollNext()) {
			nextBtn.removeAttribute('disabled');
		} else {
			nextBtn.setAttribute('disabled', 'disabled');
		}
	};

	emblaApi.on('select', togglePrevNextBtnsState).on('init', togglePrevNextBtnsState).on('reInit', togglePrevNextBtnsState);
};
